import axios from "axios";
import NProgress from "nprogress";
import store from "../../store/store";
import RouterUtils from "../../utils/BaseUtils/RouterUtils";

const apiClient = axios.create({
  baseURL: window.__env.api.baseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  timeout: 50000
});

apiClient.interceptors.request.use(config => {
  const token = store.getters["user/getUserTokenFromLocalStorage"];
  if (token != null) {
    config.headers.Authorization = token;
  }
  return config;
});
apiClient.interceptors.response.use(response => {
  NProgress.done();
  if (response.data.responseCode === "92") {
    RouterUtils.changeRouteTo("login");
  }

  return response;
});

export default {
  fetchProductTypes(payload) {
    return apiClient.post("/readProductTemplate", JSON.stringify(payload));
  },

  allProductFields(requestBody) {
    return apiClient.post("/readProductForm", JSON.stringify(requestBody));
  },

  createProduct(requestBody) {
    return apiClient.post("/createProduct", JSON.stringify(requestBody));
  },

  updateProduct(requestBody) {
    return apiClient.post("/updateProduct", JSON.stringify(requestBody));
  },

  readProduct(requestBody) {
    return apiClient.post("/readProduct", JSON.stringify(requestBody));
  }
};
